// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/list_project_images.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ProjectImage } from "./vision_asset_pb";
import { file_vision_assets_v1_vision_asset } from "./vision_asset_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/list_project_images.proto.
 */
export const file_vision_assets_v1_list_project_images: GenFile = /*@__PURE__*/
  fileDesc("Cip2aXNpb24vYXNzZXRzL3YxL2xpc3RfcHJvamVjdF9pbWFnZXMucHJvdG8SF3Byb3Rvcy52aXNpb24uYXNzZXRzLnYxIq4CChhMaXN0UHJvamVjdEltYWdlc1JlcXVlc3QSSAoGcGFyYW1zGAEgASgLMjgucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuTGlzdFByb2plY3RJbWFnZXNSZXF1ZXN0LlBhcmFtcxJQCgpwYWdpbmF0aW9uGAIgASgLMjwucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuTGlzdFByb2plY3RJbWFnZXNSZXF1ZXN0LlBhZ2luYXRpb24aMQoGUGFyYW1zEhIKCnByb2plY3RfaWQYASABKAkSEwoLbG9jYXRpb25faWQYAiABKAkaQwoKUGFnaW5hdGlvbhIRCglwYWdlX3NpemUYASABKAUSFAoKbmV4dF90b2tlbhgCIAEoCUgAQgwKCnBhZ2VfdG9rZW4ioQIKGUxpc3RQcm9qZWN0SW1hZ2VzUmVzcG9uc2USSQoGcmVzdWx0GAEgASgLMjkucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuTGlzdFByb2plY3RJbWFnZXNSZXNwb25zZS5SZXN1bHQSUQoKcGFnaW5hdGlvbhgCIAEoCzI9LnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLkxpc3RQcm9qZWN0SW1hZ2VzUmVzcG9uc2UuUGFnaW5hdGlvbho/CgZSZXN1bHQSNQoGaW1hZ2VzGAEgAygLMiUucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuUHJvamVjdEltYWdlGiUKClBhZ2luYXRpb24SFwoPbmV4dF9wYWdlX3Rva2VuGAEgASgJYgZwcm90bzM", [file_vision_assets_v1_vision_asset]);

/**
 * @generated from message protos.vision.assets.v1.ListProjectImagesRequest
 */
export type ListProjectImagesRequest = Message<"protos.vision.assets.v1.ListProjectImagesRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.ListProjectImagesRequest.Params params = 1;
   */
  params?: ListProjectImagesRequest_Params | undefined;

  /**
   * @generated from field: protos.vision.assets.v1.ListProjectImagesRequest.Pagination pagination = 2;
   */
  pagination?: ListProjectImagesRequest_Pagination | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.ListProjectImagesRequest.
 * Use `create(ListProjectImagesRequestSchema)` to create a new message.
 */
export const ListProjectImagesRequestSchema: GenMessage<ListProjectImagesRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_list_project_images, 0);

/**
 * @generated from message protos.vision.assets.v1.ListProjectImagesRequest.Params
 */
export type ListProjectImagesRequest_Params = Message<"protos.vision.assets.v1.ListProjectImagesRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string location_id = 2;
   */
  locationId: string;
};

/**
 * Describes the message protos.vision.assets.v1.ListProjectImagesRequest.Params.
 * Use `create(ListProjectImagesRequest_ParamsSchema)` to create a new message.
 */
export const ListProjectImagesRequest_ParamsSchema: GenMessage<ListProjectImagesRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_list_project_images, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.ListProjectImagesRequest.Pagination
 */
export type ListProjectImagesRequest_Pagination = Message<"protos.vision.assets.v1.ListProjectImagesRequest.Pagination"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from oneof protos.vision.assets.v1.ListProjectImagesRequest.Pagination.page_token
   */
  pageToken: {
    /**
     * @generated from field: string next_token = 2;
     */
    value: string;
    case: "nextToken";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message protos.vision.assets.v1.ListProjectImagesRequest.Pagination.
 * Use `create(ListProjectImagesRequest_PaginationSchema)` to create a new message.
 */
export const ListProjectImagesRequest_PaginationSchema: GenMessage<ListProjectImagesRequest_Pagination> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_list_project_images, 0, 1);

/**
 * @generated from message protos.vision.assets.v1.ListProjectImagesResponse
 */
export type ListProjectImagesResponse = Message<"protos.vision.assets.v1.ListProjectImagesResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.ListProjectImagesResponse.Result result = 1;
   */
  result?: ListProjectImagesResponse_Result | undefined;

  /**
   * @generated from field: protos.vision.assets.v1.ListProjectImagesResponse.Pagination pagination = 2;
   */
  pagination?: ListProjectImagesResponse_Pagination | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.ListProjectImagesResponse.
 * Use `create(ListProjectImagesResponseSchema)` to create a new message.
 */
export const ListProjectImagesResponseSchema: GenMessage<ListProjectImagesResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_list_project_images, 1);

/**
 * @generated from message protos.vision.assets.v1.ListProjectImagesResponse.Result
 */
export type ListProjectImagesResponse_Result = Message<"protos.vision.assets.v1.ListProjectImagesResponse.Result"> & {
  /**
   * @generated from field: repeated protos.vision.assets.v1.ProjectImage images = 1;
   */
  images: ProjectImage[];
};

/**
 * Describes the message protos.vision.assets.v1.ListProjectImagesResponse.Result.
 * Use `create(ListProjectImagesResponse_ResultSchema)` to create a new message.
 */
export const ListProjectImagesResponse_ResultSchema: GenMessage<ListProjectImagesResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_list_project_images, 1, 0);

/**
 * @generated from message protos.vision.assets.v1.ListProjectImagesResponse.Pagination
 */
export type ListProjectImagesResponse_Pagination = Message<"protos.vision.assets.v1.ListProjectImagesResponse.Pagination"> & {
  /**
   * @generated from field: string next_page_token = 1;
   */
  nextPageToken: string;
};

/**
 * Describes the message protos.vision.assets.v1.ListProjectImagesResponse.Pagination.
 * Use `create(ListProjectImagesResponse_PaginationSchema)` to create a new message.
 */
export const ListProjectImagesResponse_PaginationSchema: GenMessage<ListProjectImagesResponse_Pagination> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_list_project_images, 1, 1);

